// @flow

import { type Merchant } from './types';

export function getGoogleAnalyticsTrackingSite(merchant: Merchant): ?string {
  return merchant['google_analytics_tracking_site'];
}
